import { combineReducers } from '@reduxjs/toolkit';
import apiSlice from 'apis/apiSlice';
import confirmModalSlice from './confirmModal/confirmModalSlice';
import loadingFullScreenSlice from './loadingFullScreen/loadingFullScreenSlice';
import toastNotificationSlice from './toastNotification/toastNotificationSlice';
import customTableSlice from './customTable/customTableSlice';
import userSlice from './user/userSlice';
import inputValueSlice from './searchText/searchText';
import accordionSlice from './accordion/accordion';
import reduxUrlId from './categoriesUrl/categoriesUrl';

const rootReducer = combineReducers({
  [confirmModalSlice.name]: confirmModalSlice.reducer,
  [loadingFullScreenSlice.name]: loadingFullScreenSlice.reducer,
  [toastNotificationSlice.name]: toastNotificationSlice.reducer,
  [customTableSlice.name]: customTableSlice.reducer,
  [userSlice.name]: userSlice.reducer,
  [apiSlice.reducerPath]: apiSlice.reducer,
  [inputValueSlice.name]: inputValueSlice.reducer,
  [accordionSlice.name]: accordionSlice.reducer,
  [reduxUrlId.name]: reduxUrlId.reducer,
});

export default rootReducer;
